/**
 * @generated SignedSource<<9a0c2c32f1defe72db12641744d04e83>>
 * @relayHash 26a271225bd77d8ec2f3b76e4a965267
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26a271225bd77d8ec2f3b76e4a965267

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteBodyMeasurementInput = {
  id: string;
};
export type deDeleteBodyMeasurementMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_deleteBodyMeasurementInput;
};
export type deDeleteBodyMeasurementMutation$data = {
  readonly deleteBodyMeasurement: {
    readonly bodyMeasurement: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deDeleteBodyMeasurementMutation = {
  response: deDeleteBodyMeasurementMutation$data;
  variables: deDeleteBodyMeasurementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deDeleteBodyMeasurementMutation",
    "selections": [
      {
        "alias": "deleteBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "de_deleteBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyMeasurement",
            "kind": "LinkedField",
            "name": "bodyMeasurement",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deDeleteBodyMeasurementMutation",
    "selections": [
      {
        "alias": "deleteBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "de_deleteBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyMeasurement",
            "kind": "LinkedField",
            "name": "bodyMeasurement",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "26a271225bd77d8ec2f3b76e4a965267",
    "metadata": {},
    "name": "deDeleteBodyMeasurementMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "af45c149c386ac2183b456a663039cbd";

export default node;
